/**
 * WordPress dependencies
 */
import {
	registerBlockType,
} from '@wordpress/blocks';

// Extensions
import './extensions/store';
import './extensions/hooks';
// import './extensions/team-styles';

import * as container from './blocks/container';
import * as map from './blocks/map';
import * as team from './blocks/team';
import * as teamMember from './blocks/team/team-member';
import * as countDown from './blocks/count-down';

/**
 * Function to register an individual block.
 *
 * @param {Object} block The block to be registered.
 *
 */
const registerBlock = ( block ) => {
	if ( ! block ) {
		return;
	}

	const { category } = block;

	const { name, settings } = block;

	// if ( ! supportsCollections() && ! name.includes( 'gallery' ) ) {
	// 	category = 'coblocks';
	// }

	registerBlockType( name, {
		category,
		...settings,
	} );
};

/**
 * Function to register blocks provided by CoBlocks.
 */
export const registerCoBlocksBlocks = () => {
	[
		container,
		map,
		team,
		teamMember,
		countDown,
	].forEach( registerBlock );
};

registerCoBlocksBlocks();
